import site from '../../lib/seo/site.json';

/**
 * Global storefront footer.
 */
export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer glass">
      <div>Audio at Play</div>
      <div>{site.description}</div>
      <div>Free and paid releases. Sign in to purchase or download from Audio at Play.</div>
      <nav aria-label="Agent integration">
        <a className="text-link" href="/developers">Agent developers: start here</a>
        {' | '}<a className="text-link" href="/agent-solana-usdc-checkout.md">Agent integration guide</a>
        {' | '}<a className="text-link" href="/openapi.json">OpenAPI</a>
        {' | '}<a className="text-link" href="/agent-solana-client.cjs">Node signing client</a>
      </nav>
      <div>Agent purchases require authorized pilot access.</div>
      <nav aria-label="About and licensing">
        <a className="text-link" href="/about">About Audio at Play</a>
        {' | '}<a className="text-link" href="/licensing">Audio licenses</a>
      </nav>
      <div>&copy; {year} Audio at Play. All rights reserved.</div>
    </footer>
  );
}
